export default __webpack_public_path__ + "static/media/about-team-15.ca75de6f.jpg";